import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useLocation, useParams } from "react-router-dom";
import { H2 } from "@/components/ui/typography";
import { RFSData, useRFS as useRFSQuery } from "@/api/rfs";
import { HPTARCreateForm } from "@/features/hptar/HPTARCreateForm";

interface HPTARCreateProps {
  useRFS?: ({ id }: { id: string }) => { data?: RFSData; isPending: boolean };
}
export function HPTARCreate({ useRFS = useRFSQuery }: HPTARCreateProps) {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: rfs } = useRFS({ id });
  const { state } = useLocation();

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "RFS",
          },
          {
            href: "/rfs/rfs",
            label: "RFS List",
          },
          {
            href: state?.from ? state.from : `/rfs/rfs/${id}`,
            label: "Detail",
          },
          {
            href: `/rfs/rfs/${id}/hptar/create`,
            label: "Create HPTAR",
          },
        ]}
      />
      <H2>HPTAR - {rfs?.clusterId}</H2>
      <HPTARCreateForm />
    </>
  );
}
